import React, { useEffect, useState } from 'react';
import CommonLayout from '../../../layouts/CommonLayout';
import './QuizList.css'; // Import your CSS file
import { allAPiServicesCall } from '../../../services/apiServices';
import { getAuthConfig } from '../../../services/apiUtils';
import { ROUTE_CONSTANT } from "../../../routes/constant";
import { useNavigate, Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { extractObjectId } from '../../../utils/utils';

const QuizList = () => {
    const [quizzes, setQuizzes] = useState([]);
    const [genres, setGenres] = useState([]);
    const [selectedGenre, setSelectedGenre] = useState('All');
    const [answeredQuestions, setAnsweredQuestions] = useState({});
    const [hasAnswered, setHasAnswered] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(20);
    const navigate = useNavigate();

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
    useEffect(() => {
        const fetchGenres = async () => {
            try {
                const response = await allAPiServicesCall.getGenres({}, getAuthConfig())
                if (response && response.status >= 200) {
                    setGenres(response.data);
                }
            } catch (error) {
                console.error('Error fetching genres:', error);
            }
        };

        fetchGenres();
    }, []);

    useEffect(() => {
        const fetchQuizzes = async () => {
            try {
                const payload = { genre: selectedGenre, page: currentPage }
                const response = await allAPiServicesCall.getAllQuizs(getAuthConfig(), payload, navigate)
                console.log(response)
                if (response && response.status >=  200) {
                    setQuizzes(response.data.quizzes);
                    setTotalPages(response.data.pagination.totalPages)
                }
            } catch (error) {
                console.error('Error fetching quizzes:', error);
            }
        };

        fetchQuizzes();
    }, [selectedGenre, currentPage]);

    const handleAnswerClick = (quizId, option) => {
        const quiz = quizzes.find(q => extractObjectId(q._id) === quizId);
        const isCorrect = option === quiz.correctAnswer;

        setAnsweredQuestions(prev => ({
            ...prev,
            [quizId]: { selectedOption: option, isCorrect }
        }));

        setHasAnswered(prev => ({
            ...prev,
            [quizId]: true
        }));
    };

    const editHref = (id) =>
    ROUTE_CONSTANT.COMMON.EDIT_QUIZ.replace(":id", String(id));

    return (
        <CommonLayout>
            <div className="quiz-page">
                {/* Header Section */}
                <div className="quiz-header">
                    <div className="quiz-header-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" fill="currentColor"/>
                        </svg>
                    </div>
                    <div className="quiz-header-text">
                        <h1 className="quiz-title">Quiz Questions</h1>
                        <p className="quiz-subtitle">Test your music knowledge with our quiz collection</p>
                    </div>
                </div>

                {/* Genre Filter Section */}
                <div className="genre-selector">
                    <label>Select Genre</label>
                    <select onChange={(e) => setSelectedGenre(e.target.value)} value={selectedGenre} className='form-select'>
                        <option value="all">All Genres</option>
                        {genres.map((genre) => (
                            <option key={extractObjectId(genre._id)} value={genre.genreName}>
                                {genre.genreName}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Quiz Cards Grid */}
                <div className="quiz-container">
                {quizzes.length === 0 ? (
                    <div className="quiz-empty-state">
                        <div className="quiz-empty-icon">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" fill="currentColor"/>
                            </svg>
                        </div>
                        <h3 className="quiz-empty-title">No Quizzes Found</h3>
                        <p className="quiz-empty-text">No quiz available for this genre. Try selecting a different genre.</p>
                    </div>
                ) : (
                    <>
{

                                        quizzes.map((quiz) => {
                        const quizId = extractObjectId(quiz._id);
                        return (
                        <div key={quizId} className="quiz-card">
                            <h3>{quiz.question}</h3>
                            <div className="options-container">
                                {['A', 'B', 'C', 'D'].map((optionKey) => {
                                    const isSelected = answeredQuestions[quizId]?.selectedOption === optionKey;
                                    const isCorrect = answeredQuestions[quizId]?.isCorrect;
                                    const isRightAnswer = quiz.correctAnswer === optionKey;

                                    let buttonClass = 'option-button';
                                    if (isSelected) {
                                        buttonClass += isCorrect ? ' correct' : ' incorrect';
                                    } else if (hasAnswered[quizId] && isRightAnswer) {
                                        buttonClass += ' correct';
                                    }

                                    return (
                                        <button
                                            key={optionKey}
                                            onClick={() => handleAnswerClick(quizId, optionKey)}
                                            className={buttonClass}
                                        >
                                            {quiz[`option${optionKey}`]}
                                        </button>
                                    );
                                })}
                                <Link
                                    className=" btn-sm btn-primary"
                                    to={editHref(quizId)}
                                >
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" class="fs-3 text-danger" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"></path></svg>
                                </Link>
                            </div>
                        </div>
                    );})

                }

            {quizzes.length > 0 && (
            <div className="pagination-container">
              <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
                Previous
              </Button>
              <span>
                {currentPage} / {totalPages}
              </span>
              <Button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </Button>
            </div>
          )}

                    </>
                )}
                </div>
            </div>
        </CommonLayout>
    );
};

export default QuizList;